import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      margin: theme.spacing(2, 2, 0, 2),
      padding: theme.spacing(1),
      borderRadius: 6,
      backgroundColor: '#F3F3F3',
    },
  }),
);

export default useStyles;
